import { Tcity, initialCity } from "./city";

export interface Tdistrict {
    id?: number;
    districtName: string;
    districtCode: string;
    city: Tcity;
}

export const initialDistrict: Tdistrict = {
    districtName: "",
    districtCode: "",
    city: initialCity
}